import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const AutocompleteList = forwardRef((props, ref) => (
  <Box
    ref={ref}
    component="ul"
    sx={{
      mt: 0,
      p: 0,
      listStyle: 'none',
      overflow: 'auto',
      borderRadius: 4,
      border: '2px solid',
      borderColor: 'gray.A300',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
      backgroundColor: 'gray.A100',
      WebkitOverflowScrolling: 'touch',
      overscrollBehavior: 'contain',
      '& > li:not(:last-child)': {
        mb: 2.5,
      },
    }}
    {...props}
  />
));

AutocompleteList.propTypes = {
  children: PropTypes.node,
};

AutocompleteList.defaultProps = {
  children: null,
};

export default AutocompleteList;
